import { render, staticRenderFns } from "./getHistoryView.vue?vue&type=template&id=cd182eee&scoped=true"
import script from "./getHistoryView.vue?vue&type=script&lang=js"
export * from "./getHistoryView.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd182eee",
  null
  
)

export default component.exports